import { useFotoUrl } from "../foto";
import { anzeigename, initialen, type Benennbar } from "../namen";
import s from "./ui.module.css";

interface Props {
  person: (Benennbar & { foto_pfad?: string | null }) | null | undefined;
  groesse?: number;
}

/** Foto oder Initialen. Das Foto ist nur für angemeldete aktive Personen sichtbar. */
export function Avatar({ person, groesse = 34 }: Props) {
  const url = useFotoUrl(person?.foto_pfad);
  const stil = { width: groesse, height: groesse, fontSize: Math.max(13, Math.round(groesse / 2.8)) };
  if (url) return <img className={s.avatar} style={stil} src={url} alt="" aria-hidden="true" />;
  return (
    <span className={s.avatar} style={stil} aria-hidden="true" title={anzeigename(person)}>
      {initialen(person)}
    </span>
  );
}
